/* Mio Ajuda — lógica (Shopify: Assets > mio-ajuda.js). Configurações no bloco CONFIG logo abaixo. */
(function () {
  'use strict';

  /* ======================= CONFIGURAÇÃO (ajuste aqui) ======================= */
  var CONFIG = {
    // INTEGRAÇÃO: URLs do backend (obrigatórias). A cliente se identifica pelo número do ticket + WhatsApp.
    endpoint: '',            // POST multipart  -> cria o ticket  -> { ticket }
    acompanharEndpoint: '',  // POST JSON { ticket, whatsapp } -> dados do ticket (login)
    mensagemEndpoint: '',    // POST JSON { ticket, whatsapp, texto } -> ticket atualizado
    reaberturaEndpoint: '',  // POST JSON { ticket, whatsapp, motivo } -> ticket atualizado (status volta para "aguardando")
    prazoAtendimento: 'até 2 dias úteis',
    sacUrl: 'mailto:atendimento@miocapelli.com.br',                       // "Falar com o SAC"
    whatsappUrl: 'https://wa.me/5512997890917?text=Oi!%20Preciso%20de%20ajuda%20com%20o%20meu%20ticket',
    maxFotos: 5,
    maxFotoMB: 10,
    minDetalhes: 100         // mínimo de caracteres em "Conta pra gente o que aconteceu"
  };

  /* ======================= DADOS DO FLUXO ======================= */
  var I = {
    danificado: '<path d="M21 8l-9-5-9 5v8l9 5 9-5V8z"/><path d="M3 8l9 5 9-5"/><path d="M12 13l-2 3 2 1-1 3"/>',
    incorreto: '<rect x="3" y="3" width="18" height="18" rx="4"/><path d="M9.6 9.5a2.5 2.5 0 114 2c-.8.6-1.6 1-1.6 2M12 17h.01"/>',
    extravio: '<path d="M1.5 6h12v10h-12z"/><path d="M13.5 9h4l3 3v4h-7z"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>',
    reembolso: '<circle cx="12" cy="12" r="9"/><path d="M12 6.5v11M15 9.4c0-1-1.3-1.7-3-1.7s-3 .8-3 2 1.3 1.6 3 2 3 .9 3 2-1.3 2-3 2-3-.8-3-1.8"/>',
    troca: '<path d="M17 3l4 4-4 4M21 7H8a4 4 0 00-4 4M7 21l-4-4 4-4M3 17h13a4 4 0 004-4"/>',
    atraso: '<circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>'
  };
  var MOTIVOS = [
    { id: 'danificado', titulo: 'Produtos danificados',          desc: 'Chegou quebrado, vazado ou com defeito', foto: true },
    { id: 'incorreto',  titulo: 'Produto faltando ou incorreto', desc: 'Veio um item diferente ou faltou algo', foto: true },
    { id: 'extravio',   titulo: 'Extravio ou falha na entrega',  desc: 'O pedido não chegou ou a entrega deu errado' },
    { id: 'reembolso',  titulo: 'Reembolso ou cancelamento',     desc: 'Quero cancelar o pedido ou receber o meu dinheiro de volta' },
    { id: 'troca',      titulo: 'Troca ou devolução',            desc: 'Quero trocar ou devolver um produto' },
    { id: 'atraso',     titulo: 'Pedido atrasado',               desc: 'Passou do prazo e ainda não chegou' }
  ];
  var SOLUCOES = [
    { id: 'reembolso_total',   titulo: 'Quero receber o reembolso total', resumo: 'Reembolso total',   desc: 'A gente devolve o valor integral do pedido.' },
    { id: 'reembolso_parcial', titulo: 'Quero o reembolso parcial',       resumo: 'Reembolso parcial', desc: 'Devolvemos só o valor do item ou da parte afetada.' },
    { id: 'reenvio',           titulo: 'Quero receber o produto',         resumo: 'Receber o produto', desc: 'A gente envia o produto pra você (reenvio ou troca).' }
  ];
  // Como cada status do painel interno aparece para a cliente (etapa 0..3 = linha do tempo)
  var STATUS_CLIENTE = {
    novo:               { etapa: 0, rotulo: 'Recebemos o seu pedido', tom: '',       titulo: 'Recebemos a sua solicitação 🩷', texto: 'Ela já está na fila da nossa equipe. Logo começamos a olhar o seu caso.' },
    triagem:            { etapa: 1, rotulo: 'Em análise',             tom: '',       titulo: 'Estamos analisando o seu caso', texto: 'A nossa equipe está olhando tudo com atenção. Assim que tiver novidade, a gente conta por aqui.' },
    aguardando:         { etapa: 1, rotulo: 'Em análise',             tom: '',       titulo: 'Seu caso já foi analisado 🩷', texto: 'Ele está na fila para a nossa equipe iniciar o atendimento. Assim que tiver novidade, a gente conta por aqui.' },
    em_andamento:       { etapa: 2, rotulo: 'Em atendimento',         tom: '',       titulo: 'Estamos cuidando do seu caso', texto: 'Uma pessoa da nossa equipe está cuidando do seu atendimento neste momento.' },
    aguardando_cliente: { etapa: 2, rotulo: 'Precisamos de você',     tom: 'alerta', titulo: 'Precisamos de uma informação sua', texto: 'Responde a nossa mensagem aqui embaixo, na conversa, pra gente continuar o seu atendimento.' },
    aguardando_reenvio: { etapa: 2, rotulo: 'Reenvio aprovado',       tom: '',       titulo: 'Reenvio aprovado! 🩷', texto: 'Estamos preparando o envio do seu produto. Assim que sair, mandamos o código de rastreio por aqui.' },
    reenviado:          { etapa: 2, rotulo: 'Reenvio a caminho',      tom: '',       titulo: 'Seu produto está a caminho 🩷', texto: 'O reenvio já foi postado. Você pode acompanhar pelo código de rastreio que enviamos na conversa.' },
    aguardando_reembolso: { etapa: 2, rotulo: 'Reembolso aprovado',   tom: '',       titulo: 'Reembolso aprovado! 🩷', texto: 'Estamos finalizando o pagamento. Ele volta pela mesma forma de pagamento da compra, e o prazo pra aparecer depende do banco ou da operadora do cartão.' },
    concluido:          { etapa: 3, rotulo: 'Resolvido',              tom: 'ok',     titulo: 'Tudo certo, caso resolvido! 🩷', texto: 'Esperamos que você tenha ficado feliz com a solução. Obrigada pela paciência!' },
    recusado:           { etapa: 3, rotulo: 'Finalizado',             tom: 'fim',    titulo: 'Caso finalizado', texto: 'Analisamos com carinho, mas não conseguimos seguir com o pedido como solicitado. Dá uma olhada na mensagem da equipe aqui embaixo ou chama a gente no WhatsApp.' }
  };
  var ETAPAS = ['Recebido', 'Em análise', 'Em andamento', 'Finalizado'];
  var UFS = ['AC','AL','AP','AM','BA','CE','DF','ES','GO','MA','MT','MS','MG','PA','PB','PR','PE','PI','RJ','RN','RS','RO','RR','SC','SP','SE','TO'];

  /* ======================= UTIL ======================= */
  var root = document.getElementById('mio-sac');
  var form = root.querySelector('#msac-form');
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || root).querySelectorAll(s)); }
  function digits(v) { return String(v || '').replace(/\D/g, ''); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c]; }); }
  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }
  function fmtDH(iso) { try { return new Date(iso).toLocaleString('pt-BR', { day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit' }); } catch (e) { return ''; } }
  function fmtD(iso) { try { return new Date(iso).toLocaleDateString('pt-BR'); } catch (e) { return ''; } }
  function ss(k, v) { try { if (v === undefined) return sessionStorage.getItem(k); if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} return null; }

  var state = { step: 1, motivo: null, solucao: null, files: [], enviando: false, concluido: false, view: 'novo', sessao: null, ticket: null };

  /* ======================= MÁSCARAS E VALIDAÇÕES ======================= */
  var masks = {
    cpf: function (v) { v = digits(v).slice(0, 11); return v.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2'); },
    phone: function (v) { v = digits(v).slice(0, 11); if (v.length <= 10) return v.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{4})(\d)/, '$1-$2'); return v.replace(/(\d{2})(\d)/, '($1) $2').replace(/(\d{5})(\d)/, '$1-$2'); },
    cep: function (v) { v = digits(v).slice(0, 8); return v.replace(/(\d{5})(\d)/, '$1-$2'); }
  };
  function validCPF(v) {
    v = digits(v);
    if (v.length !== 11 || /^(\d)\1{10}$/.test(v)) return false;
    for (var t = 9; t < 11; t++) {
      var s = 0;
      for (var i = 0; i < t; i++) s += parseInt(v[i], 10) * (t + 1 - i);
      var d = ((s * 10) % 11) % 10;
      if (d !== parseInt(v[t], 10)) return false;
    }
    return true;
  }
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  function validPhone(v) { var d = digits(v); if (d.length !== 10 && d.length !== 11) return false; if (+d.slice(0, 2) < 11) return false; return d.length === 10 || d.charAt(2) === '9'; }
  function hojeISO() { var d = new Date(); return d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-' + ('0' + d.getDate()).slice(-2); }
  function fmtData(iso) { var p = String(iso).split('-'); return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : iso; }
  function pixValida(tipo, chave) {
    chave = String(chave || '').trim();
    if (tipo === 'cpf') return validCPF(chave);
    if (tipo === 'email') return validEmail(chave);
    if (tipo === 'celular') return validPhone(chave);
    return /^[0-9a-zA-Z-]{32,36}$/.test(chave);
  }
  function pixNorm(tipo, v) { v = String(v || '').trim(); return (tipo === 'cpf' || tipo === 'celular') ? digits(v) : v.toLowerCase(); }

  /* ======================= ERROS POR CAMPO ======================= */
  function setErr(name, msg) {
    var f = $('[data-field="' + name + '"]');
    if (!f) return;
    var p = $('[data-err="' + name + '"]', f);
    if (msg === null) { f.classList.remove('is-invalid'); $$('input,select,textarea', f).forEach(function (el) { el.removeAttribute('aria-invalid'); }); return; }
    f.classList.add('is-invalid');
    if (p && msg) p.textContent = msg;
    $$('input,select,textarea', f).forEach(function (el) { el.setAttribute('aria-invalid', 'true'); });
  }
  function clearErrs(scope) { $$('.is-invalid', scope).forEach(function (f) { f.classList.remove('is-invalid'); $$('[aria-invalid]', f).forEach(function (el) { el.removeAttribute('aria-invalid'); }); }); }
  function focusFirstInvalid(scope) {
    var f = $('.is-invalid', scope);
    if (!f) return;
    var el = $('input:not([type=checkbox]):not([type=file]),select,textarea', f) || $('input', f);
    if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
    var r = f.getBoundingClientRect();
    if (r.top < 80 || r.bottom > window.innerHeight - 90) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ======================= RENDER DAS OPÇÕES ======================= */
  function optHTML(name, o, icon) {
    return '<label class="msac-opt"><input type="radio" name="' + name + '" value="' + o.id + '">' +
      (icon ? '<span class="ico"><svg viewBox="0 0 24 24" aria-hidden="true">' + icon + '</svg></span>' : '') +
      '<span><span class="t">' + esc(o.titulo) + '</span><span class="d">' + esc(o.desc) + '</span></span></label>';
  }
  $('#msac-motivos').innerHTML = MOTIVOS.map(function (m) { return optHTML('motivo', m, I[m.id]); }).join('');
  $('#msac-uf').innerHTML = '<option value="">UF</option>' + UFS.map(function (u) { return '<option>' + u + '</option>'; }).join('');
  $('#msac-data').max = hojeISO();

  function renderSolucoes() {
    var lista = SOLUCOES.filter(function (s) { return !(state.motivo === 'reembolso' && s.id === 'reenvio'); });
    if (state.solucao && !byId(lista, state.solucao)) state.solucao = null;
    $('#msac-solucoes').innerHTML = lista.map(function (s) { return optHTML('solucao', s, null); }).join('');
    if (state.solucao) { var r = $('input[value="' + state.solucao + '"]', $('#msac-solucoes')); if (r) r.checked = true; }
  }

  /* ======================= ABAS (nova solicitação / acompanhar) ======================= */
  var TEXTOS = {
    novo: ['Oi, amiga! Vamos resolver isso juntas', 'Aconteceu algo com o seu pedido? Conta pra gente em poucos passinhos que a nossa equipe cuida de tudo com todo o carinho.'],
    acompanhar: ['Acompanhe o seu ticket', 'Veja em que etapa o seu caso está e converse com a nossa equipe, tudo por aqui.']
  };
  function setView(v, silent) {
    state.view = v;
    $$('.msac-tab').forEach(function (t) { t.setAttribute('aria-selected', String(t.getAttribute('data-view') === v)); });
    $('#msac-view-novo').hidden = v !== 'novo';
    $('#msac-view-acomp').hidden = v !== 'acompanhar';
    $('#msac-title').textContent = TEXTOS[v][0];
    $('#msac-lead').textContent = TEXTOS[v][1];
    $('#msac-header').hidden = (v === 'novo' && state.concluido);
    if (v === 'acompanhar') renderAcomp();
    if (history.replaceState) { try { history.replaceState(null, '', v === 'acompanhar' ? '#acompanhar' : location.pathname + location.search); } catch (e) {} }
    if (!silent) { var top = root.getBoundingClientRect().top; if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }
  $$('.msac-tab').forEach(function (t) { t.addEventListener('click', function () { setView(t.getAttribute('data-view')); }); });

  /* ======================= NAVEGAÇÃO DO FORMULÁRIO ======================= */
  function go(step, silent) {
    state.step = step;
    $$('.msac-panel[data-panel]').forEach(function (p) { p.hidden = String(p.getAttribute('data-panel')) !== String(step); });
    $$('#msac-steps li').forEach(function (li) {
      var s = +li.getAttribute('data-s');
      li.classList.toggle('is-active', s === step);
      li.classList.toggle('is-done', s < step);
      if (s === step) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
    var m = byId(MOTIVOS, state.motivo);
    $$('[data-ctx="motivo"]').forEach(function (el) { el.textContent = m ? m.titulo : ''; });
    if (step === 2) { var obr = !!(m && m.foto); $('#msac-fotos-req').hidden = !obr; $('#msac-fotos-opt').hidden = obr; }
    if (step === 3) { renderSolucoes(); updateSolucaoUI(); }
    if (silent) return;
    var h = $('.msac-panel[data-panel="' + step + '"] .msac-h');
    var top = root.getBoundingClientRect().top;
    if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    if (h) h.focus({ preventScroll: true });
  }
  function updateSolucaoUI() {
    var s = state.solucao, reemb = s === 'reembolso_total' || s === 'reembolso_parcial';
    $('#b-total').hidden = s !== 'reembolso_total';
    $('#b-parcial').hidden = s !== 'reembolso_parcial';
    $('#b-pix').hidden = !reemb;
    $('#b-endereco').hidden = s !== 'reenvio';
  }

  /* ======================= VALIDAÇÃO POR ETAPA ======================= */
  function validarEtapa1() {
    clearErrs($('[data-panel="1"]'));
    if (!state.motivo) { setErr('motivo', 'Escolhe um motivo pra continuar, tá?'); return false; }
    return true;
  }
  function validarEtapa2() {
    var scope = $('[data-panel="2"]'); clearErrs(scope);
    var ok = true;
    function bad(n, msg) { setErr(n, msg); ok = false; }
    if (form.nome.value.trim().split(/\s+/).filter(Boolean).length < 2) bad('nome', 'Coloca o nome e o sobrenome, tá?');
    if (!validEmail(form.email.value.trim())) bad('email', 'Esse e-mail parece estar incompleto. Confere pra gente?');
    if (!validPhone(form.whatsapp.value)) bad('whatsapp', 'Informa o WhatsApp com DDD.');
    if (!validCPF(form.cpf.value)) bad('cpf', 'Confere o CPF, ele parece estar incorreto.');
    var d = form.dataPedido.value;
    if (!d) bad('dataPedido', 'Informa a data do pedido.');
    else if (d > hojeISO()) bad('dataPedido', 'A data não pode ser no futuro.');
    else if (d < '2000-01-01') bad('dataPedido', 'Confere a data do pedido.');
    var nDet = form.detalhes.value.trim().length;
    if (nDet < CONFIG.minDetalhes) bad('detalhes', 'Conta um pouquinho mais pra gente: escreve pelo menos ' + CONFIG.minDetalhes + ' caracteres (faltam ' + (CONFIG.minDetalhes - nDet) + ').');
    var m = byId(MOTIVOS, state.motivo);
    if (m && m.foto && state.files.length === 0) bad('fotos', 'Precisamos de ao menos uma foto do problema, tá?');
    if (!ok) focusFirstInvalid(scope);
    return ok;
  }
  function validarEtapa3() {
    var scope = $('[data-panel="3"]'); clearErrs(scope);
    var ok = true, s = state.solucao;
    function bad(n, msg) { setErr(n, msg); ok = false; }
    if (!s) { setErr('solucao', 'Escolhe como você prefere resolver.'); return false; }
    if (s === 'reembolso_total' && !$('#msac-aceite').checked) bad('aceiteDevolucao');
    if (s === 'reembolso_parcial' && $('#msac-parcial').value.trim().length < 5) bad('descricaoParcial', 'Conta qual item ou valor você quer receber de volta.');
    if (s === 'reembolso_total' || s === 'reembolso_parcial') {
      var tipo = form.pixTipo.value, chave = form.pixChave.value, conf = form.pixConfirma.value;
      if (!pixValida(tipo, chave)) bad('pixChave', 'Essa chave Pix não parece válida pro tipo escolhido.');
      if (!conf.trim()) bad('pixConfirma', 'Digita a chave de novo pra confirmar.');
      else if (pixNorm(tipo, chave) !== pixNorm(tipo, conf)) bad('pixConfirma', 'As chaves não são iguais.');
    }
    if (s === 'reenvio') {
      if (digits(form.cep.value).length !== 8) bad('cep', 'Informa um CEP válido.');
      if (!form.uf.value) bad('uf', 'Seleciona o estado.');
      if (form.rua.value.trim().length < 3) bad('rua', 'Informa a rua ou avenida.');
      if (!form.numero.value.trim()) bad('numero', 'Informa o número (ou S/N).');
      if (form.bairro.value.trim().length < 2) bad('bairro', 'Informa o bairro.');
      if (form.cidade.value.trim().length < 2) bad('cidade', 'Informa a cidade.');
      if (!$('#msac-aceite-end').checked) bad('aceiteEndereco');
    }
    if (!ok) focusFirstInvalid(scope);
    return ok;
  }

  /* ======================= EVENTOS DO FORMULÁRIO ======================= */
  $('#msac-view-novo').addEventListener('click', function (e) {
    var next = e.target.closest('[data-next]');
    if (next) {
      var n = next.getAttribute('data-next');
      if (n === '1' && validarEtapa1()) go(2);
      else if (n === '2' && validarEtapa2()) go(3);
      return;
    }
    var back = e.target.closest('[data-goto]');
    if (back) go(+back.getAttribute('data-goto'));
  });
  // Enter num campo de texto das etapas 1/2 avança a etapa (em vez de tentar enviar o formulário)
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || e.isComposing || state.step === 3) return;
    var t = e.target;
    if (t.tagName === 'TEXTAREA' || t.tagName === 'BUTTON' || t.type === 'file') return;
    e.preventDefault();
    if (state.step === 1 && validarEtapa1()) go(2);
    else if (state.step === 2 && validarEtapa2()) go(3);
  });
  form.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'motivo') { state.motivo = t.value; setErr('motivo', null); var m = byId(MOTIVOS, state.motivo); }
    if (t.name === 'solucao') { state.solucao = t.value; setErr('solucao', null); updateSolucaoUI(); }
    if (t.name === 'pixTipo') { form.pixChave.value = ''; form.pixConfirma.value = ''; setErr('pixChave', null); setErr('pixConfirma', null); setPixPlaceholder(); }
    var f = t.closest('.msac-field'); if (f && t.type === 'checkbox') f.classList.remove('is-invalid');
  });
  function setPixPlaceholder() {
    var ph = { cpf: '000.000.000-00', email: 'voce@email.com', celular: '(11) 91234-5678', aleatoria: 'Cole a chave aleatória' }[form.pixTipo.value];
    form.pixChave.placeholder = ph; form.pixConfirma.placeholder = ph;
    form.pixChave.inputMode = form.pixConfirma.inputMode = (form.pixTipo.value === 'email' || form.pixTipo.value === 'aleatoria') ? 'text' : 'numeric';
  }
  setPixPlaceholder();
  form.addEventListener('input', function (e) {
    var t = e.target, mk = t.getAttribute('data-mask');
    if (mk) t.value = masks[mk](t.value);
    if (t.name === 'pixChave' || t.name === 'pixConfirma') {
      var tp = form.pixTipo.value;
      if (tp === 'cpf') t.value = masks.cpf(t.value); else if (tp === 'celular') t.value = masks.phone(t.value);
    }
    if (t.id === 'msac-detalhes') atualizarContador();
    var f = t.closest('.msac-field');
    if (f && f.classList.contains('is-invalid')) f.classList.remove('is-invalid');
    if (t.id === 'msac-cep' && digits(t.value).length === 8) buscarCEP(digits(t.value));
  });

  function atualizarContador() {
    var n = form.detalhes.value.trim().length, falta = CONFIG.minDetalhes - n, el = $('#msac-detalhes-cont');
    el.textContent = falta > 0 ? 'Escreve pelo menos ' + CONFIG.minDetalhes + ' caracteres (' + n + '/' + CONFIG.minDetalhes + ').' : n + ' caracteres 🩷';
  }

  /* CEP: preenche rua/bairro/cidade/UF via ViaCEP (opcional; se falhar, a cliente digita) */
  var cepCtl = null, cepSeq = 0;
  function buscarCEP(cep) {
    var hint = $('#msac-cep-hint'); hint.hidden = false; hint.textContent = 'Buscando o endereço…';
    var ctl = window.AbortController ? new AbortController() : null;
    if (cepCtl) cepCtl.abort();
    cepCtl = ctl; cepSeq++; var meu = cepSeq;
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, 8000);
    fetch('https://viacep.com.br/ws/' + cep + '/json/', ctl ? { signal: ctl.signal } : undefined).then(function (r) { return r.json(); }).then(function (j) {
      clearTimeout(to);
      if (meu !== cepSeq || digits(form.cep.value) !== cep) return; // resposta de um CEP antigo
      if (j && !j.erro) {
        if (!form.rua.value) form.rua.value = j.logradouro || '';
        if (!form.bairro.value) form.bairro.value = j.bairro || '';
        if (!form.cidade.value) form.cidade.value = j.localidade || '';
        if (j.uf) form.uf.value = j.uf;
        $$('[data-field="rua"],[data-field="bairro"],[data-field="cidade"],[data-field="uf"]').forEach(function (f) { f.classList.remove('is-invalid'); });
        hint.textContent = 'Achamos o endereço! Confere os dados e informa o número.';
        if (!form.numero.value) form.numero.focus({ preventScroll: true });
      } else { hint.textContent = 'Não achamos esse CEP. Preenche o endereço manualmente.'; }
    }).catch(function () { clearTimeout(to); if (meu !== cepSeq) return; hint.textContent = 'Não deu pra buscar o CEP agora. Preenche manualmente.'; });
  }

  /* ======================= FOTOS ======================= */
  var fotosInput = $('#msac-fotos'), drop = $('#msac-drop');
  function addFotos(list) {
    var erro = '';
    Array.prototype.forEach.call(list, function (f) {
      if (!/^image\//.test(f.type)) { erro = 'Envia só imagens (JPG, PNG, HEIC…).'; return; }
      if (f.size > CONFIG.maxFotoMB * 1048576) { erro = 'Cada foto pode ter no máximo ' + CONFIG.maxFotoMB + ' MB.'; return; }
      if (state.files.length >= CONFIG.maxFotos) { erro = 'Você pode enviar até ' + CONFIG.maxFotos + ' fotos.'; return; }
      state.files.push({ file: f, url: URL.createObjectURL(f) });
    });
    renderFotos();
    if (erro) setErr('fotos', erro); else setErr('fotos', null);
  }
  function renderFotos() {
    $('#msac-thumbs').innerHTML = state.files.map(function (it, i) {
      return '<div class="msac-thumb"><img src="' + it.url + '" alt="Foto ' + (i + 1) + '"><button type="button" data-rm="' + i + '" aria-label="Remover foto ' + (i + 1) + '">×</button></div>';
    }).join('');
  }
  function clearFotos() { state.files.forEach(function (it) { URL.revokeObjectURL(it.url); }); state.files = []; renderFotos(); setErr('fotos', null); }
  fotosInput.addEventListener('change', function () { addFotos(fotosInput.files); fotosInput.value = ''; });
  $('#msac-thumbs').addEventListener('click', function (e) {
    var b = e.target.closest('[data-rm]'); if (!b) return;
    var it = state.files.splice(+b.getAttribute('data-rm'), 1)[0]; if (it) URL.revokeObjectURL(it.url); renderFotos();
  });
  ['dragenter', 'dragover'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.add('is-over'); }); });
  ['dragleave', 'drop'].forEach(function (ev) { drop.addEventListener(ev, function (e) { e.preventDefault(); drop.classList.remove('is-over'); }); });
  drop.addEventListener('drop', function (e) { if (e.dataTransfer && e.dataTransfer.files) addFotos(e.dataTransfer.files); });

  /* ======================= ENVIO DA SOLICITAÇÃO ======================= */
  function montarFormData() {
    var fd = new FormData(), s = state.solucao;
    fd.append('motivo', state.motivo);
    ['nome', 'email', 'whatsapp', 'cpf', 'dataPedido', 'detalhes'].forEach(function (k) { fd.append(k, form[k].value.trim()); });
    fd.append('solucao', s);
    if (s === 'reembolso_parcial') fd.append('descricaoParcial', form.descricaoParcial.value.trim());
    if (s === 'reembolso_total' || s === 'reembolso_parcial') { fd.append('pixTipo', form.pixTipo.value); fd.append('pixChave', form.pixChave.value.trim()); }
    if (s === 'reenvio') ['cep', 'rua', 'numero', 'complemento', 'bairro', 'cidade', 'uf'].forEach(function (k) { fd.append(k, form[k].value.trim()); });
    if (s === 'reembolso_total') fd.append('aceiteDevolucao', $('#msac-aceite').checked ? 'sim' : 'nao');
    if (s === 'reenvio') fd.append('aceiteEndereco', $('#msac-aceite-end').checked ? 'sim' : 'nao');
    state.files.forEach(function (it) { fd.append('fotos', it.file, it.file.name); });
    return fd;
  }
  function enviar() {
    // INTEGRAÇÃO: a solicitação vai para CONFIG.endpoint (multipart). Deve devolver { ticket }.
    if (!CONFIG.endpoint) return Promise.reject(new Error('endpoint não configurado'));
    // Timeout de 45s para não deixar o botão preso em "Enviando…" (fotos podem demorar mais que texto)
    var ctl = window.AbortController ? new AbortController() : null;
    var to = setTimeout(function () { if (ctl) ctl.abort(); }, 45000);
    // INTEGRAÇÃO: limite as tentativas por IP/e-mail no backend (anti-spam) e valide tudo de novo no servidor.
    return fetch(CONFIG.endpoint, { method: 'POST', body: montarFormData(), signal: ctl ? ctl.signal : undefined }).then(function (r) {
      clearTimeout(to);
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }, function (err) { clearTimeout(to); throw err; });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (state.enviando) return;
    if (!validarEtapa3()) return;
    if ($('#msac-hp').value) { mostrarConclusao({ ticket: '0000' }); return; } // robô: finge sucesso, não envia
    var btn = $('#msac-enviar'), banner = $('#msac-banner');
    banner.hidden = true; state.enviando = true; btn.disabled = true; btn.textContent = 'Enviando…';
    enviar().then(function (r) {
      if (!r || !r.ticket) throw new Error('Resposta sem número de ticket');
      mostrarConclusao(r);
    }).catch(function () {
      banner.textContent = 'Ai, não conseguimos enviar agora. Confere a sua internet e tenta de novo. Se continuar, chama a gente no WhatsApp 🩷';
      banner.hidden = false;
    }).then(function () { state.enviando = false; btn.disabled = false; btn.textContent = 'Enviar solicitação'; });
  });

  /* ======================= TELA FINAL ======================= */
  function mascararPix(tipo, v) {
    v = String(v).trim();
    if (tipo === 'email') { var p = v.split('@'); return (p[0].slice(0, 2) + '•••@' + (p[1] || '')); }
    var d = (tipo === 'cpf' || tipo === 'celular') ? digits(v) : v;
    return '••••' + d.slice(-4);
  }
  function linhasResumo() {
    var m = byId(MOTIVOS, state.motivo), s = byId(SOLUCOES, state.solucao);
    var linhas = [['Motivo', m.titulo], ['Solução desejada', s.resumo], ['Nome', form.nome.value.trim()], ['E-mail', form.email.value.trim()], ['Data do pedido', fmtData(form.dataPedido.value)]];
    if (state.files.length) linhas.push(['Fotos enviadas', String(state.files.length)]);
    if (state.solucao === 'reembolso_parcial') linhas.push(['Item/valor', form.descricaoParcial.value.trim()]);
    if (state.solucao === 'reembolso_total' || state.solucao === 'reembolso_parcial') {
      linhas.push(['Chave Pix', mascararPix(form.pixTipo.value, form.pixChave.value)]);
      linhas.push(['Forma do reembolso', 'Mesma forma de pagamento da compra']);
    }
    if (state.solucao === 'reenvio') {
      linhas.push(['Endereço de envio', form.rua.value.trim() + ', ' + form.numero.value.trim() + (form.complemento.value.trim() ? ' – ' + form.complemento.value.trim() : '') + ' · ' + form.bairro.value.trim() + ' · ' + form.cidade.value.trim() + '/' + form.uf.value + ' · CEP ' + form.cep.value]);
    }
    return linhas;
  }
  function resumoHTML(linhas) { return linhas.map(function (l) { return '<div><dt>' + esc(l[0]) + '</dt><dd>' + esc(l[1]) + '</dd></div>'; }).join(''); }
  function mostrarConclusao(r) {
    $('#msac-resumo').innerHTML = resumoHTML(linhasResumo());
    $('#msac-ticket-num').textContent = r.ticket;
    $('#msac-prazo').textContent = CONFIG.prazoAtendimento;
    $('#msac-link-sac').href = CONFIG.sacUrl;
    state.ultimo = { ticket: r.ticket, whatsapp: digits(form.whatsapp.value) };
    state.concluido = true;
    state.files.forEach(function (it) { URL.revokeObjectURL(it.url); }); // libera as miniaturas
    form.hidden = true; $('#msac-steps').hidden = true; $('#msac-header').hidden = true;
    var done = $('#msac-done'); done.hidden = false;
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    $('.msac-h', done).focus({ preventScroll: true });
  }
  $('#msac-copy').addEventListener('click', function () {
    var n = $('#msac-ticket-num').textContent, b = this;
    function ok() { b.textContent = 'Copiado!'; setTimeout(function () { b.textContent = 'Copiar'; }, 1800); }
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(n).then(ok, function () {});
    else { var t = document.createElement('textarea'); t.value = n; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); ok(); } catch (x) {} document.body.removeChild(t); }
  });
  // "Acompanhar meu ticket": já leva a cliente logada com os dados que ela acabou de informar
  $('#msac-go-acomp').addEventListener('click', function () {
    var u = state.ultimo;
    if (u) { $('#msac-l-ticket').value = u.ticket; $('#msac-l-whatsapp').value = masks.phone(u.whatsapp); }
    setView('acompanhar');
    if (u) entrar(u.ticket, u.whatsapp);
  });

  /* ======================= LOGIN + ACOMPANHAMENTO ======================= */
  $('#msac-link-wpp').href = CONFIG.whatsappUrl;
  $('#msac-l-ticket').addEventListener('input', function () { this.value = digits(this.value).slice(0, 10); this.closest('.msac-field').classList.remove('is-invalid'); });
  $('#msac-l-whatsapp').addEventListener('input', function () { this.value = masks.phone(this.value); this.closest('.msac-field').classList.remove('is-invalid'); });

  function buscarTicket(ticket, whatsapp) {
    // INTEGRAÇÃO: POST JSON { ticket, whatsapp (só dígitos) } em CONFIG.acompanharEndpoint (ver cabeçalho).
    if (!CONFIG.acompanharEndpoint) return Promise.reject(new Error('endpoint não configurado'));
    return fetch(CONFIG.acompanharEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ticket: ticket, whatsapp: digits(whatsapp) }) }).then(function (r) {
      if (r.status === 404 || r.status === 401) throw { naoEncontrado: true };
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }
  function postarMensagem(ticket, whatsapp, texto) {
    // INTEGRAÇÃO: POST JSON { ticket, whatsapp, texto } em CONFIG.mensagemEndpoint -> ticket atualizado.
    if (!CONFIG.mensagemEndpoint) return Promise.reject(new Error('endpoint não configurado'));
    return fetch(CONFIG.mensagemEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ticket: ticket, whatsapp: digits(whatsapp), texto: texto }) }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function reabrirTicket(ticket, whatsapp, motivo) {
    // INTEGRAÇÃO: POST JSON { ticket, whatsapp, motivo } em CONFIG.reaberturaEndpoint -> ticket atualizado.
    // O backend só aceita se o ticket estiver "concluido"; muda o status para "aguardando" ("Aguardando atendimento"
    // no painel do SAC), registra no histórico { tipo: "reabertura", de: "concluido", para: "aguardando", por: "Cliente", motivo }
    // e grava o motivo como mensagem da cliente na conversa.
    if (!CONFIG.reaberturaEndpoint) return Promise.reject(new Error('endpoint não configurado'));
    return fetch(CONFIG.reaberturaEndpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ticket: ticket, whatsapp: digits(whatsapp), motivo: motivo }) }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  function entrar(ticket, whatsapp) {
    var banner = $('#msac-login-banner'), btn = $('#msac-login-btn');
    banner.hidden = true; btn.disabled = true; btn.textContent = 'Procurando…';
    return buscarTicket(ticket, whatsapp).then(function (t) {
      state.sessao = { ticket: String(ticket), whatsapp: digits(whatsapp) }; state.ticket = t;
      ss('msac-sessao', JSON.stringify(state.sessao));
      renderAcomp(true);
    }).catch(function (err) {
      banner.textContent = (err && err.naoEncontrado)
        ? 'Hmm, não encontramos um ticket com esses dados. Confere o número e o WhatsApp que você usou na solicitação, tá?'
        : 'Não conseguimos buscar o seu ticket agora. Tenta de novo em instantes ou chama a gente no WhatsApp 🩷';
      banner.hidden = false;
    }).then(function () { btn.disabled = false; btn.textContent = 'Acompanhar meu ticket'; });
  }
  $('#msac-login-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var t = $('#msac-l-ticket').value.trim(), m = $('#msac-l-whatsapp').value.trim(), ok = true;
    $('[data-lfield="ticket"]').classList.toggle('is-invalid', !t); if (!t) ok = false;
    $('[data-lfield="whatsapp"]').classList.toggle('is-invalid', !validPhone(m)); if (!validPhone(m)) ok = false;
    if (!ok) { var f = $('.msac-field.is-invalid input', $('#msac-login-form')); if (f) f.focus(); return; }
    entrar(t, m);
  });

  function renderAcomp(focar) {
    var logada = !!(state.sessao && state.ticket);
    $('#msac-login').hidden = logada;
    $('#msac-trk').hidden = !logada;
    if (!logada) return;
    var t = state.ticket, st = STATUS_CLIENTE[t.status] || STATUS_CLIENTE.novo, m = byId(MOTIVOS, t.motivo);
    $('#msac-t-num').textContent = t.ticket;
    $('#msac-t-meta').textContent = (m ? m.titulo + ' · ' : '') + 'aberto em ' + fmtD(t.criadoEm);
    var hist = t.historico || [], ultimo = hist.length ? hist[hist.length - 1] : null;
    if (t.status === 'aguardando' && ultimo && ultimo.tipo === 'reabertura') {
      st = { etapa: 1, rotulo: 'Reaberto', tom: '', titulo: 'Recebemos o seu pedido de reabertura 🩷', texto: 'O seu ticket voltou para a fila e a nossa equipe vai retomar o atendimento em breve.' };
    }
    var pill = $('#msac-t-pill'); pill.textContent = st.rotulo; pill.className = 'msac-pill' + (st.tom ? ' ' + st.tom : '');
    var msg = $('#msac-t-msg'); msg.className = 'msac-status-msg' + (st.tom ? ' ' + st.tom : '');
    msg.innerHTML = '<strong>' + esc(st.titulo) + '</strong>' + esc(st.texto);

    // linha do tempo: marca a data em que cada etapa foi alcançada
    var datas = {};
    (t.historico || []).forEach(function (h) { var e = (STATUS_CLIENTE[h.status] || {}).etapa; if (e != null && !datas[e]) datas[e] = h.em; });
    var check = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
    $('#msac-t-tl').innerHTML = ETAPAS.map(function (nome, i) {
      var cls = i < st.etapa ? 'is-done' : (i === st.etapa ? (st.etapa === 3 ? 'is-done' : 'is-now') : '');
      return '<li class="' + cls + '"><span class="dot">' + (cls === 'is-done' ? check : '') + '</span><span class="tt">' + nome + (datas[i] ? '<span class="dd"> · ' + fmtDH(datas[i]) + '</span>' : '') + '</span></li>';
    }).join('');

    // conversa
    var msgs = t.mensagens || [];
    $('#msac-t-chat').innerHTML = msgs.length ? msgs.map(function (x) {
      var eq = x.de === 'equipe';
      return '<div class="msac-msg ' + (eq ? 'equipe' : 'cliente') + '"><span class="who">' + (eq ? 'Equipe Mio Capelli 🩷' : 'Você') + '</span>' + esc(x.texto) + '<span class="when">' + fmtDH(x.em) + '</span></div>';
    }).join('') : '<div class="msac-chat-empty">Ainda não temos mensagens por aqui. Assim que a equipe responder, aparece nesta conversa.</div>';

    var fechado = t.status === 'concluido' || t.status === 'recusado';
    $('#msac-reply-form').hidden = fechado; $('#msac-t-closed').hidden = !fechado;
    var podeReabrir = t.status === 'concluido';
    $('#msac-reopen').hidden = !podeReabrir;
    if (!podeReabrir) { $('#msac-reopen-form').hidden = true; $('#msac-reopen-open').setAttribute('aria-expanded', 'false'); }
    $('#msac-t-resumo').innerHTML = resumoHTML(t.resumo || []);
    if (focar) { $('#msac-t-num').focus({ preventScroll: true }); var top = root.getBoundingClientRect().top; if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
  }

  $('#msac-reply-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var ta = $('#msac-reply'), texto = ta.value.trim(), b = $('#msac-reply-btn'), banner = $('#msac-reply-banner');
    if (texto.length < 2) { ta.focus(); return; }
    banner.hidden = true; b.disabled = true; b.textContent = 'Enviando…';
    postarMensagem(state.sessao.ticket, state.sessao.whatsapp, texto).then(function (t) {
      state.ticket = t; ta.value = ''; renderAcomp();
      var chat = $('#msac-t-chat'); if (chat.lastElementChild) chat.lastElementChild.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }).catch(function () {
      banner.textContent = 'Não conseguimos enviar a sua mensagem agora. Tenta de novo, tá?'; banner.hidden = false;
    }).then(function () { b.disabled = false; b.textContent = 'Enviar mensagem'; });
  });
  $('#msac-reopen-open').addEventListener('click', function () {
    var f = $('#msac-reopen-form'), abrir = f.hidden;
    f.hidden = !abrir; this.setAttribute('aria-expanded', String(abrir));
    if (abrir) $('#msac-reopen-motivo').focus();
  });
  $('#msac-reopen-form').addEventListener('submit', function (e) {
    e.preventDefault();
    var ta = $('#msac-reopen-motivo'), motivo = ta.value.trim(), b = $('#msac-reopen-btn'), banner = $('#msac-reopen-banner');
    if (motivo.length < 5) { banner.textContent = 'Conta pra gente o motivo da reabertura (pelo menos algumas palavras), tá?'; banner.hidden = false; ta.focus(); return; }
    banner.hidden = true; b.disabled = true; b.textContent = 'Enviando…';
    reabrirTicket(state.sessao.ticket, state.sessao.whatsapp, motivo).then(function (t) {
      state.ticket = t; ta.value = ''; renderAcomp();
    }).catch(function () {
      banner.textContent = 'Não conseguimos reabrir o ticket agora. Tenta de novo em instantes ou chama a gente no WhatsApp 🩷'; banner.hidden = false;
    }).then(function () { b.disabled = false; b.textContent = 'Enviar pedido de reabertura'; });
  });
  $('#msac-t-refresh').addEventListener('click', function () {
    var b = this; b.disabled = true; b.textContent = 'Atualizando…';
    buscarTicket(state.sessao.ticket, state.sessao.whatsapp).then(function (t) { state.ticket = t; renderAcomp(); }).catch(function () {}).then(function () { b.disabled = false; b.textContent = 'Atualizar'; });
  });
  $('#msac-t-logout').addEventListener('click', function () {
    state.sessao = null; state.ticket = null; ss('msac-sessao', null);
    $('#msac-l-ticket').value = ''; $('#msac-l-whatsapp').value = '';
    renderAcomp(); $('#msac-login .msac-h').focus({ preventScroll: true });
  });
  $('#msac-t-new').addEventListener('click', function () { setView('novo'); });

  /* ======================= INÍCIO ======================= */
  $('#msac-link-sac').href = CONFIG.sacUrl;
  go(1, true); atualizarContador();
  var guardada = null;
  try { guardada = JSON.parse(ss('msac-sessao') || 'null'); } catch (e) {}
  if (location.hash === '#acompanhar' || guardada) {
    setView('acompanhar', true);
    if (guardada) { buscarTicket(guardada.ticket, guardada.whatsapp).then(function (t) { state.sessao = guardada; state.ticket = t; renderAcomp(); }).catch(function () { ss('msac-sessao', null); }); }
  }
})();